import { TrendingUp, TrendingDown, Minus, CircleHelp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { classifyRecentDirection } from "../lib/recentDirection";

const MAP = {
  bullish: { icon: TrendingUp, cls: "text-bullish", bg: "bg-bullish/10 border-bullish/20" },
  bearish: { icon: TrendingDown, cls: "text-bearish", bg: "bg-bearish/10 border-bearish/20" },
  mixed: { icon: Minus, cls: "text-neutral", bg: "border-border" },
  unavailable: { icon: CircleHelp, cls: "text-muted-foreground", bg: "border-border" },
};

export function TrendBadge({ asset, trend, className = "" }) {
  const { t } = useTranslation();
  const direction = asset ? classifyRecentDirection(asset) : (trend === "neutral" ? "mixed" : trend || "unavailable");
  const cfg = MAP[direction] || MAP.unavailable;
  const Icon = cfg.icon;

  const label = direction === "bullish"
    ? t("common.bullish")
    : direction === "bearish"
      ? t("common.bearish")
      : direction === "mixed"
        ? t("localizedContent.ui.mixed", { defaultValue: "Mixed / Flat" })
        : t("localizedContent.ui.unavailable", { defaultValue: "Unavailable" });

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium uppercase tracking-wider ${cfg.cls} ${cfg.bg} ${className}`}
      data-testid={`trend-badge-${direction}`}
    >
      <Icon className="h-3.5 w-3.5" />
      <span title={t("localizedContent.ui.recentDirectionTitle", { defaultValue: "Recent direction — derived from available 24h, 7d and 30d price changes; descriptive only, not an investment recommendation" })}>
        {t("localizedContent.ui.recentDirection", { defaultValue: "Recent Direction" })}: {label}
      </span>
    </span>
  );
}
